import HeaderPortal from "components/portal/header-portal";
import { List, Icon } from "components";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import { Button } from "ui/components/button";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { eventBus } from "utils/eventBus";
import { useRemoveTechStack } from "./mutation";
import CreateTechStackDialog from "./input";
import { MENU } from "icons";

export default function TechStack() {
    const { casestudyId } = useParams();
    const [dialogOpen, setDialogOpen] = useState(false);
    const removeTechStack = useRemoveTechStack({
        onSuccess: () => {
            eventBus.emit("refresh:list", `case_studies_tech_stacktechstack${casestudyId}`);
        },
    });
    const fields = [
        "id",
        "tech_stack.name",
        "tech_stack.type",
        "case_study.id",
    ];
    const columns = [
        {
            id: "tech_stack.name",
            header: "Name",
            accessorKey: "tech_stack.name",
        },
        {
            id: "tech_stack.type",
            header: "Type",
            accessorKey: "tech_stack.type",
        },
        {
            id: "actions",
            header: "",
            accessorKey: "employee.id",
            cell: ({ row }) => {
                const id = row.original.id;
                return (
                    <div className="flex items-center gap-2 justify-end opacity-0 group-hover:opacity-100 transition">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button size="icon" variant="outline">
                                    <Icon icon={MENU} className="size-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                                <DropdownMenuItem
                                    onClick={() => removeTechStack.mutateAsync({ id })}
                                    disabled={removeTechStack.isPending}
                                    className="cursor-pointer"
                                >
                                    Delete
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                );
            },
            sortable: false,
            meta: { align: "right" },
        },
    ];

    const defaultFilters = {
        case_study: {
            id: {
                _eq: casestudyId,
            }
        },
    };

    const handleCreate = () => {
        setDialogOpen(true);
    };

    return (
        <div className="flex-1">
            <HeaderPortal>
                <Button onClick={handleCreate}>
                    Add
                </Button>
            </HeaderPortal>
            <List
                title="Tech Stack"
                storageKey={`techstack${casestudyId}`}
                endPoint="case_studies_tech_stack"
                filters={defaultFilters}
                columns={columns}
                meta={{ fields }}
                hidePagination={true}
                showSearch={false}
                perPage={10}
                sortBy="tech_stack.name"
            />
            <CreateTechStackDialog
                open={dialogOpen}
                onOpenChange={setDialogOpen}
            />
        </div>
    );
}
